// src/pages/KnowledgeBase/FundPlannerGuide.jsx
import React, { useState } from 'react';
import localDoc from './FundPlannerGuideData.json'; // must exist in this folder exactly

export default function FundPlannerGuide() {
  const [sections] = useState(localDoc);

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-baseline justify-between">
        <h1 className="text-2xl font-semibold text-brand1">FundPlanner User Guide</h1>
      </div>
      {sections.map((s) => <Section key={s.id} section={s} />)}
    </div>
  );
}

function Section({ section }) {
  const { id, title, type, body, items, note } = section;
  return (
    <section id={id} className="rounded-2xl border border-app bg-app text-app p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-app">{title}</h2>

      {type === 'text' && body && (
        <p
          className="text-sm text-app mt-2 whitespace-pre-line"
          dangerouslySetInnerHTML={{ __html: md(body) }}
        />
      )}

      {type === 'bullets' && Array.isArray(items) && (
        <ul className="list-disc pl-5 text-sm text-app mt-2 space-y-1">
          {items.map((li, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: md(li) }} />
          ))}
        </ul>
      )}

      {type === 'steps' && Array.isArray(items) && (
        <ol className="list-decimal pl-5 text-sm text-app mt-2 space-y-1">
          {items.map((li, i) => (
            <li key={i} dangerouslySetInnerHTML={{ __html: md(li) }} />
          ))}
        </ol>
      )}

      {note && (
        <div className="mt-3 text-xs text-muted">
          <strong>Note:</strong>{' '}
          <span dangerouslySetInnerHTML={{ __html: md(note) }} />
        </div>
      )}
    </section>
  );
}

function md(s = '') {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/`([^`]+)`/g, '<code>$1</code>');
}
